/* ==================================================================
 *  people_mypage_people#edit PCのみ
 *  #HACK people_mypage/pc/pages/people.es6を作る
 * ================================================================== */
// NOTE: jQuery 3.x では $('selector').ready() がセレクタを無視して全ページで発火するため、
// $(function(){}) + 明示的なページガードに変更する
$(() => {
  if (!$("body.people_mypage.edit.pc").length) return;

  $(document).on("focus", ".editProfileTextArea", function () {
    const width = $(this).outerWidth();
    const { placeholder } = $(this).get(0);
    const html = `<div class="jsHoverPlaceholder"><div style="max-width: ${width}px">${placeholder}</div></div>`;
    $(this).before($(html).fadeIn(200));
  });
  $(document).on("blur", ".editProfileTextArea", () => {
    $(".jsHoverPlaceholder").fadeOut(200);
    $(".jsHoverPlaceholder").remove();
  });
});
